export default "/dist/files/players.65af00c80f6c0d99306f430b7176653f.svg";